import styled from 'styled-components'
import { colors } from 'styles/colors'

export const AccordionItem = styled.div`
    overflow: hidden;
    width: 100%;
`

export const AccordionTitle = styled.div`
    padding: 20px 10px;
    cursor: pointer;

    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 19px;
    font-weight: 500;
    line-height: 24.13px;
    color: ${colors.gray_50};

    svg {
        flex-shrink: 0;
        float: right;
        width: 15px;
        transition: transform 200ms;

        #arrow {
            stroke: ${(p) => p.color};
        }
    }

    &.Accordion__title--open {
        svg {
            transform: rotate(180deg);
        }
    }
`

export const AccordionArrow = styled.span`
    transition: transform 0.3s ease;

    ${({ isOpen }) =>
        isOpen &&
        `
    transform: rotate(180deg);
  `}
`

export const AccordionContent = styled.div`
    max-height: 0;
    overflow: hidden;

    transition:
        max-height 0.3s ease,
        padding 0.3s ease;
    padding: 0 10px;
    text-align: left;

    ${({ isOpen }) =>
        isOpen &&
        `
        max-height: 300px; /* Ajuste conforme necessário */
        padding: 0 10px 20px;
  `}
`
